import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { useEffect } from 'react'
import { Inter_Tight, JetBrains_Mono } from 'next/font/google'
import { motionStore } from '@/lib/motion'
import { PageRuler } from '@/components/generals/page-ruler'
import { PageTransition } from '@/components/generals/page-transition'
import { Preloader } from '@/components/generals/preloader'
import { SiteCrosshair } from '@/components/generals/site-crosshair'

const sans = Inter_Tight({
    subsets: ['latin', 'latin-ext', 'greek'],
    weight: ['400', '500', '600'],
    display: 'swap'
})

const mono = JetBrains_Mono({
    subsets: ['latin', 'latin-ext', 'greek'],
    weight: ['400', '500'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    useEffect(() => {
        motionStore.init()
    }, [])

    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <Preloader />

            <PageTransition>
                <Component {...pageProps} />
            </PageTransition>

            <PageRuler />
            <SiteCrosshair />
        </div>
    )
}

export default App
